import { useState } from "react";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import HighchartsMore from "highcharts/highcharts-more";
import { currencyFormat, updateChartTheme } from "../../../utils/helpsers";
import noData from "highcharts/modules/no-data-to-display"

// Load Highcharts modules
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
HighchartsMore(Highcharts);
noData(Highcharts)

/**
 * Column chart using highcharts library.
 * @param {array} data - An array data to be rendered in the chart.
*/

const StackedChart = ({ data }) => {
  const [showRawDataTable, setShowRawDataTable] = useState(false);

    const StackedChartData = {
        chart: {
            type: 'column',
            backgroundColor: '#fff',
        },
        title: {
            text: 'District vs Employee Contribution',
            align: 'center'
        },
        xAxis: {
            categories: data.categories
        },
        yAxis: {
            min: 0,
            title: {
                text: ''
            },
            stackLabels: {
                enabled: false
            }
        },
        tooltip: {
            formatter: function () {
                return `${this.series.name}: <strong>${currencyFormat(this.point.y)}</strong>
                <br/>Total: ${this.point.stackTotal} `
            }
        },
        plotOptions: {
            column: {
                stacking: 'normal',
            }
        },
      exporting: {
        tableCaption: false,
        buttons: {
          contextButton: {
            menuItems: [
              "viewFullscreen",
              {
                text: "Toggle Light/Dark mode",
                onclick: function () {
                  updateChartTheme(this);
                }
              },
              {
                separator: true,
              },
              {
                text: "Download PDF document",
                onclick: function () {
                  this.exportChart({
                    type: "application/pdf",
                  });
                },
              },
              {
                text: "Download CSV",
                onclick: function () {
                  this.downloadCSV();
                },
              },
              {
                text: "Download XLS",
                onclick: function () {
                  this.downloadXLS();
                },
              },
              {
                separator: true,
              },
              {
                text: showRawDataTable ? "Hide Raw Data Table" : "Show Raw Data Table",
                onclick: function () {

                  if (showRawDataTable) {
                    setShowRawDataTable(!showRawDataTable);
                    this.hideData();

                  } else {
                    setShowRawDataTable(!showRawDataTable);
                    this.viewData()
                  }
                }
              }
            ],
          },
        },
      },
        series: data.series
    }

    return (
        <Box>
            <HighchartsReact
                highcharts={Highcharts}
                options={StackedChartData}
            />
        </Box>
    )
}
StackedChart.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
}

export default StackedChart;
